import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SuSupplyOrderService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/su-supply-orders', params);
    }

    store(body: any): Observable<any> {
        return super.post('/su-supply-orders', body);
    }

    show(supplyOrderId: number): Observable<any> {
        return super.get(`/su-supply-orders/${supplyOrderId}`);
    }

    edit(supplyOrderId: number): Observable<any> {
        return super.get(`/su-supply-orders/${supplyOrderId}/edit`);
    }

    update(supplyOrderId: number, body: any): Observable<any> {
        return super.put(`/su-supply-orders/${supplyOrderId}`, body);
    }

    updateMetadata(supplyOrderId: number, body: {
        internal_comment?: string | null;
        expected_reception_date?: string | null;
        lines?: {
            id: number;
            expected_reception_date?: string;
            qty?: number;
            unit_price?: number;
            delete?: boolean;
        }[];
        new_lines?: {
            sku: string;
            qty: number;
            unit_price?: number;
            expected_reception_date?: string;
        }[];
    }): Observable<any> {
        return super.patch(`/su-supply-orders/${supplyOrderId}/metadata`, body);
    }

    updateProductPurchasePrice(supplyOrderId: number, body: { line_ids: number[]; unit_price: number }): Observable<any> {
        return super.post(`/su-supply-orders/${supplyOrderId}/purchase-price`, body);
    }

    receive(suSupplyOrderId: number): Observable<any> {
        return super.get(`/su-supply-orders/${suSupplyOrderId}/receive`);
    }

    lines(supplyOrderId: number): Observable<any> {
        return super.get(`/su-supply-orders/${supplyOrderId}/lines`);
    }

    indexLines(params: any): Observable<any> {
        return super.get('/su-supply-order-lines', params);
    }

    line(lineId: number): Observable<any> {
        return super.get(`/su-supply-order-lines/${lineId}`);
    }

    send(supplyOrderId: number, options?: { manual?: boolean }): Observable<any> {
        return super.post(`/su-supply-orders/${supplyOrderId}/send`, {
            manual: options?.manual ?? false,
        });
    }

    confirm(supplyOrderId: number, body: {
        expected_reception_date?: string;
        confirmation_pdf?: File | null;
        lines?: { id: number; expected_reception_date: string }[];
    }): Observable<any> {
        const form = new FormData();
        if (body.expected_reception_date) {
            form.append('expected_reception_date', body.expected_reception_date);
        }
        if (body.confirmation_pdf) {
            form.append('confirmation_pdf', body.confirmation_pdf);
        }
        (body.lines ?? []).forEach((line, index) => {
            form.append(`lines[${index}][id]`, String(line.id));
            form.append(`lines[${index}][expected_reception_date]`, line.expected_reception_date);
        });

        return super.post(`/su-supply-orders/${supplyOrderId}/confirm`, form);
    }

    storeReceive(body: any) {
        return super.post(`/su-supply-orders/receive`, body);
    }

    cancelQuantityLeft(supplyOrderId: number, lineIds?: number[]): Observable<any> {
        return super.post(`/su-supply-orders/${supplyOrderId}/cancel-quantity-left`, lineIds?.length ? { line_ids: lineIds } : {});
    }

    getCommands(): Observable<any> {
        return super.get('/su-supply-orders/get-commands');
    }

    getCommand(id: string): Observable<any> {
        return super.post(`/su-supply-orders/get-command`, { id });
    }

    productsForOrder(params: { supplier_id: string; warehouse_id?: number | null; supply_order_id?: number | null }): Observable<any> {
        return super.get('/su-supply-orders/products-for-order', params);
    }

    pdf(supplyOrderId: number): Observable<any> {
        return super.getFile(`/su-supply-orders/${supplyOrderId}/pdf`);
    }

    print(body: any): Observable<any> {
        return super.post(`/su-supply-orders/print`, body);
    }

    linkableSaleLines(lineId: number): Observable<any> {
        return super.get(`/su-supply-order-lines/${lineId}/linkable-sale-lines`);
    }

    linkSaleLine(lineId: number, saleOrderLineId: number): Observable<any> {
        return super.post(`/su-supply-order-lines/${lineId}/link`, { sale_order_line_id: saleOrderLineId });
    }

    unlinkSaleLine(lineId: number): Observable<any> {
        return super.delete(`/su-supply-order-lines/${lineId}/link`);
    }
}
